
<div>
  <EditForm
    :activity-data="activity"
    :entities="entities"
    :users="users"
    :handle-create="meta.handleCreate"
    :handle-update="meta.handleUpdate"
    @onSuccess="handleOnSuccess"
    @onCancel="closeModal"
  />
</div>
